<template>
  <div>
    <div ref="editor" v-once class="editor" v-html="value" />
    <!-- <Popup
      v-model="colorPopupActive"
      :top="colorPopupTop"
      :left="colorPopupLeft"
    >
      <div
        class="card"
        @click.stop
      >
        <div class="card-body">{{ colorPopupActive }}{{ colorPopupColor }}</div>
      </div>
    </Popup> -->
    <!-- <div
      v-if="colorPopupActive"
      class="position-fixed top-0 start-0 bottom-0 end-0 overflow-hidden"
      style="z-index: 1000; backdrop-filter: blur(8px);"
      @click.stop = "colorPopupActive=false"
    >
      <div
        class="card position-absolute top-50 start-50 translate-middle"
        @click.stop
      >
        <div class="card-body">{{ colorPopupActive }}{{ colorPopupColor }}</div>
      </div>
    </div> -->
  </div>
</template>
<script>
import MediumEditor from "medium-editor";
import "medium-editor/dist/css/medium-editor.css";
import "./Editor.scss";
import FontSizeButton from "./FontSizeButton";
import FontNameButton from "./FontNameButton";
import LineHeightButton from "./LineHeightButton";
import CustomFieldButton from "./CustomFieldButton";
import FontColorButton from "./FontColorButton";
// import Popup from "./Popup.vue";
//import LinkForm from "./LinkForm";

export default {
  name: "Editor",
  components: {
    // Popup,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {
          extensions: {
            "font-size": new FontSizeButton(),
            "font-name": new FontNameButton(),
            "line-height": new LineHeightButton(),
            "custom-field": new CustomFieldButton(),
            "font-color": new FontColorButton(),
            //"link-form": new LinkForm(),
          },
          fontColorCallback: (button, color) => {
            const { left, bottom } = button.getBoundingClientRect();
            //event.stopPropagation();
            this.colorPopupActive = true;
            this.colorPopupLeft = left;
            this.colorPopupTop = bottom;
            this.colorPopupColor = color;
          },
          toolbar: {
            buttons: [
              "font-name",
              "font-size",
              "line-height",
              "custom-field",
              "font-color",
              "bold",
              "italic",
              "underline",
              "anchor",
              "unorderedlist",
              "justifyLeft",
              "justifyCenter",
              "justifyRight",
              "removeFormat",
            ],
            static: true,
            sticky1: true,
            align: "center",
            positionStaticToolbar(container) {
              const scrollTop =
                (this.document.documentElement &&
                  this.document.documentElement.scrollTop) ||
                this.document.body.scrollTop;
              const toolbarElement = this.getToolbarElement();
              const containerRect = container.getBoundingClientRect();
              const toolbarHeight = toolbarElement.offsetHeight;
              toolbarElement.style.top = `${Math.max(
                0,
                containerRect.top + scrollTop - toolbarHeight - 20
              )}px`;
              const toolbarWidth = toolbarElement.offsetWidth;
              const offsetLeft = containerRect.left - toolbarWidth / 4;
              toolbarElement.style.left = `${offsetLeft}px`;
            },
            updateOnEmptySelection: true,
          },
          placeholder: {
            text: "Type your text ПРЯМО ТУТ!!!",
            hideOnClick: true,
          },
        };
      },
      required: false,
    },
  },
  data() {
    return {
      editor: null,
      colorPopupActive: false,
      colorPopupColor: "",
      colorPopupTop: 0,
      colorPopupLeft: 0,
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (oldValue !== newValue) {
        const selection = this.editor.exportSelection();
        this.editor.setContent(newValue);
        this.editor.importSelection(selection);
      }
    },
  },
  created() {
    this.inputEvent = () => this.$emit("input", this.$refs.editor.innerHTML);
  },
  mounted() {
    this.editor = new MediumEditor(this.$refs.editor, this.options);
    this.editor.subscribe("editableInput", this.inputEvent);
  },
  beforeDestroy() {
    this.editor.unsubscribe("editableInput", this.inputEvent);
  },
  methods: {
    updated(value) {
      this.$emit("input", value);
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  display: block;
}
</style>
